import React from 'react';
import './ProgressBarLoader.css';

const ProgressBarLoader = ({ text = 'Loading...', color = '#008753' }) => (
  <div className="progress-bar-loader-wrapper">
    <div className="progress-bar-loader">
      <div className="progress-bar-loader-bar" style={{ background: color }} />
    </div>
    <div className="progress-bar-loader-text">{text}</div>
  </div>
);

export default ProgressBarLoader;
